import { Directive, HostListener } from '@angular/core';

import { SnLayoutService } from '../services/layout.service';

@Directive({
  selector: '[snLayoutNavbarToggle]',
})
export class SnLayoutNavbarToggleDirective {
  constructor(private readonly _layoutService: SnLayoutService) {}

  @HostListener('click')
  public onClick(): void {
    if (this._layoutService.navbar) {
      this._layoutService.navbar.toggleOpen();
    }
  }
}
